(function () {
  var config = window.UISoundsConfig;
  if (!config || (!config.hover && !config.click)) return;

  var SELECTOR = 'a, button, [role="button"], input[type="submit"], input[type="button"], select, label[for]';

  var ctx = null;
  var hoverBuffer = null;
  var clickBuffer = null;
  var ready = false;

  function getCtx() {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    return ctx;
  }

  function loadBuffer(url, onDone) {
    fetch(url)
      .then(function (r) { return r.arrayBuffer(); })
      .then(function (data) { return getCtx().decodeAudioData(data); })
      .then(onDone)
      .catch(function () {});
  }

  function isSoundEnabled() {
    var btn = document.querySelector('.site-audio-btn');
    return !btn || !btn.classList.contains('is-muted');
  }

  function playBuffer(buffer) {
    if (!buffer || !ctx || !isSoundEnabled()) return;
    if (ctx.state === 'suspended') {
      ctx.resume().then(function () { playBuffer(buffer); });
      return;
    }
    var source = ctx.createBufferSource();
    source.buffer = buffer;
    var gain = ctx.createGain();
    gain.gain.value = typeof config.volume === 'number' ? config.volume : 0.5;
    source.connect(gain);
    gain.connect(ctx.destination);
    source.start(0);
  }

  function isInteractive(el) {
    return el && el.matches && el.matches(SELECTOR) && !el.disabled && !el.closest('[disabled]');
  }

  function resumeCtx() {
    if (ctx && ctx.state === 'suspended') ctx.resume();
  }

  // Unlock AudioContext on first user gesture
  document.addEventListener('mousedown', resumeCtx, { passive: true });
  document.addEventListener('touchstart', resumeCtx, { passive: true });
  document.addEventListener('keydown', resumeCtx, { passive: true });

  // Load buffers; mark ready when both are done (or just one if only one URL set)
  var pending = (config.hover ? 1 : 0) + (config.click ? 1 : 0);
  function onLoad() { if (--pending === 0) ready = true; }

  if (config.hover) {
    loadBuffer(config.hover, function (b) { hoverBuffer = b; onLoad(); });
  }
  if (config.click) {
    loadBuffer(config.click, function (b) { clickBuffer = b; onLoad(); });
  }

  // Hover sound (capture phase so it fires on all elements)
  if (config.hover) {
    document.addEventListener('mouseenter', function (e) {
      if (ready && isInteractive(e.target)) playBuffer(hoverBuffer);
    }, { capture: true, passive: true });
  }

  // Click sound
  if (config.click) {
    document.addEventListener('click', function (e) {
      if (!ready) return;
      var el = e.target.closest ? e.target.closest(SELECTOR) : e.target;
      if (el && !el.disabled) playBuffer(clickBuffer);
    }, { passive: true });
  }
})();
